import { StyledConditionalUtil } from './types';

/**
 * @deprecated Use `cond()` from `@css/csds-components` instead.
 */
export const cond: StyledConditionalUtil = {
  if: (key, whenTrue, whenFalse) => (props) => props[key] ? whenTrue : whenFalse,
};
